<template>
    <div>
        <table class="table">
            <thead>
            <tr>
                <th class="mw-70">ID</th>
                <th>Class name</th>
                <th>Time start</th>
                <th>Time end</th>
                <th>Time</th>
                <th>DB reads</th>
                <th>DB writes</th>
                <th>DB result</th>
                <th>Output</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(tasklog, index) in tasklogs" :key="tasklog.id">
                <td>{{ tasklog.id }}</td>
                <td>{{ tasklog.classname }}</td>
                <td>{{ dateFormat(tasklog.timestart) }}</td>
                <td>{{ dateFormat(tasklog.timeend) }}</td>
                <td>{{ parseFloat(tasklog.timeend - tasklog.timestart).toFixed(2) }} seconds</td>
                <td>{{ tasklog.dbreads }}</td>
                <td>{{ tasklog.dbwrites }}</td>
                <td>{{ tasklog.result }}</td>
                <td>
                    <app-button type="primary" v-on:click="showModal(tasklog.output)">
                        <ion-icon name="information-circle-outline"></ion-icon>
                    </app-button>
                </td>
            </tr>

            <tr v-if="tasklogs.length === 0">
                <td class="table-empty" colspan="5">No logs!</td>
            </tr>
            </tbody>
        </table>

        <div class="modal fade" id="output-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog task-form" role="document">
                <div class="modal-content">
                    <div class="modal-body modal-task-log-body">
                        {{outputdata}}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    props: {
        tasklogList: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            tasklogs: {},
            outputdata: ''
        }
    },

    created() {
        this.renderList();
    },

    methods: {
        renderList() {
            this.tasklogs = this.tasklogList.length > 0
                ? JSON.parse(this.tasklogList)
                : {};
        },
        dateFormat(date) {
            return moment.unix(date).utc().format('DD MMM YYYY HH:mm:ss');
        },
        showModal(output) {
            this.outputdata = output;
            $('#output-modal').modal('show');
        },
    }
}
</script>
<style scoped lang="scss">
.modal-task-log-body {
    white-space: pre-line;
}
</style>
